import { render, staticRenderFns } from "./PaywallPlan.vue?vue&type=template&id=0fe5a993&scoped=true&"
import script from "./PaywallPlan.vue?vue&type=script&lang=ts&"
export * from "./PaywallPlan.vue?vue&type=script&lang=ts&"
import style0 from "./PaywallPlan.vue?vue&type=style&index=0&id=0fe5a993&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe5a993",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('0fe5a993', component.options)
    } else {
      api.reload('0fe5a993', component.options)
    }
    module.hot.accept("./PaywallPlan.vue?vue&type=template&id=0fe5a993&scoped=true&", function () {
      api.rerender('0fe5a993', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/premium/PaywallPlan.vue"
export default component.exports